import { render, staticRenderFns } from "./importDailog.vue?vue&type=template&id=4a0dbe22&scoped=true&"
import script from "./importDailog.vue?vue&type=script&lang=js&"
export * from "./importDailog.vue?vue&type=script&lang=js&"
import style0 from "./importDailog.vue?vue&type=style&index=0&id=4a0dbe22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0dbe22",
  null
  
)

export default component.exports